import React from "react";

function NavigationButtons({ onPrev, onNext, onFinish }) {
  return (
    <div className="flex justify-between mb-4">
      <button
        onClick={onPrev}
        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-l"
      >
        Previous
      </button>
      <button
        onClick={onNext}
        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-r"
      >
        Next
      </button>
      <button
        onClick={onFinish}
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        Finish
      </button>
    </div>
  );
}

export default NavigationButtons;
